export default class FieldsOperator {
    constructor(gudhub) {
        this.gudhub = gudhub;
    }

    mergeFieldLists(fieldsToView, fieldList) {
        let fieldsToViewCopy = JSON.parse(JSON.stringify(fieldsToView));
        let fieldListCopy = JSON.parse(JSON.stringify(fieldList));

        let existingFieldsIds = fieldListCopy.map(field => field.field_id);

        if (!fieldListCopy.length) {
            return [];
        }

        return fieldListCopy.reduce((viewArray, currentField) => {

            let positionInViewArray = null;
            let props = viewArray.find((view, index) => {
                if (currentField.field_id == view.field_id) {
                    positionInViewArray = index;
                    return true;
                }
                return false;
            });

            if (!props) {

                let defaultIntrpr = currentField.data_model && currentField.data_model.interpretation ? currentField.data_model.interpretation.find((intrpr) => {
                    return intrpr.src == 'table';
                }) || { settings: { show_field: 1 } } : { settings: { show_field: 1 } };

                if (defaultIntrpr.settings.show_field) {
                    let firstMerge = this.gudhub.util.mergeObjects({ show: 1 }, defaultIntrpr);
                    let secondMerge = this.gudhub.util.mergeObjects(firstMerge, currentField);
                    viewArray.push(secondMerge);
                }

            } else {
                viewArray[positionInViewArray] = this.gudhub.util.mergeObjects(viewArray[positionInViewArray], currentField);
            }

            return viewArray;
        }, fieldsToViewCopy).filter(function (field) {
            return field.show && existingFieldsIds.indexOf(field.field_id) != -1;
        });
    };

    createFieldsListToView(appId, tableSettingsFieldListToView) {
        const self = this;
        return new Promise(async (resolve) => {
            let fieldList = await this.gudhub.getFieldModels(appId);

            if (tableSettingsFieldListToView.length !== 0) {
                let correctFieldList = [];
                tableSettingsFieldListToView.forEach((elementFromTable, index) => {
                    let fieldOnPipe = fieldList.find((element) => elementFromTable.field_id == element.field_id);

                    if (fieldOnPipe) {
                        let show_field = fieldOnPipe.data_model.interpretation.find((intrpr) => intrpr.src == 'table');
                        if (!show_field) {
                            show_field = { settings: { show_field: 1 } }
                        }
                        correctFieldList.push({
                            field_id: fieldOnPipe.field_id,
                            show: elementFromTable.show,
                            width: elementFromTable.width ? elementFromTable.width : "150px"
                        })
                    }
                    if (index + 1 == tableSettingsFieldListToView.length) {
                        checkFiledFromPipe(correctFieldList)
                    }

                });
            } else {
                checkFiledFromPipe(tableSettingsFieldListToView);
            }

            function checkFiledFromPipe(correctFieldList) {
                let counter = 0
                fieldList.forEach((elemetFromPipe, index) => {
                    let correctFiel = correctFieldList.find((elemet) => elemetFromPipe.field_id == elemet.field_id)
                    if (!correctFiel) {
                        self.gudhub.ghconstructor.getInstance(elemetFromPipe.data_type).then((data) => {
                            if(data) {
                                let template = data.getTemplate();
                                let show_field = template.model.data_model.interpretation.find((intrpr) => intrpr.src == 'table');
                                if (!show_field) {
                                    show_field = { settings: { show_field: 1 } }
                                }
                                correctFieldList.push({
                                    field_id: elemetFromPipe.field_id,
                                    show: show_field.settings.show_field,
                                });

                                if (counter == fieldList.length - 1) {
                                    resolve(correctFieldList);
                                }
                            }
                            counter++
                        }, function errorCallback(result) {
                            counter++
                        })
                    } else {
                        if (counter == fieldList.length - 1) {
                            resolve(correctFieldList);
                        }
                        counter++
                    }
                });
            }
        });
    }

    createFieldsListToViewWithDataType(appId, tableSettingsFieldListToView) {
        return new Promise(async (resolve) => {
            let columnsToView = [];
            let fieldList = await this.gudhub.getFieldModels(appId);

            let actualFieldIds = fieldList.map((field) => +field.field_id);

            const promises = [];

            columnsToView = fieldList.reduce((viewColumsList, currentField) => {
                let field = viewColumsList.find((view, index) => {
                    if (currentField.field_id == view.field_id) {
                        return true;
                    }
                    return false;
                });

                if (!field) {

                    viewColumsList.push({
                        field_id: currentField.field_id,
                        data_type: currentField.data_type,
                    });

                    promises.push(new Promise(async (resolve) => {
                        const instance = await this.gudhub.ghconstructor.getInstance(currentField.data_type);
                        const template = instance.getTemplate();
                        const defaultIntepretation = template.model.data_model.interpretation.find((intrpr) => intrpr.src == 'table') || { settings: { show_field: 1 } };
                        viewColumsList.find(view => view.field_id == currentField.field_id).show = defaultIntepretation.settings.show_field;
                        resolve(true);
                    }));
                }

                return viewColumsList;
            }, tableSettingsFieldListToView);

            Promise.all(promises).then(() => {
                columnsToView = columnsToView.filter((field) => actualFieldIds.indexOf(field.field_id) != -1);
                resolve(columnsToView)
            })
        })
    }
}